<template>
	<Sprite/>
	<div class="layout">
		<div class="layout__aside">
			<div class="layout__aside-main">
				<router-link class="layout__logo" :to="{name: 'index'}">
					<img src="/images/Logo.svg" alt="logo" class="layout__logo-img">
				</router-link>
				<div class="layout__user">
					<UserMenu v-if="user" :page="page"></UserMenu>
					<div class="layout__user-actions" v-else>
						<button class="layout__user-action btn btn--white btn--block" type="button" @click="singIn = true">Вход</button>
						<button class="layout__user-action btn btn--block" type="button" @click="singUp = true">Регистрация</button>
					</div>
				</div>
			</div>
			<div class="layout__game-nav" v-if="gameMobNav">
				<GameNav/>
			</div>
			<div class="layout__social" v-if="!isMob">
				<Social/>
			</div>
		</div>
		<div class="layout__body">
			<div class="layout__main">
				<div class="layout__main-inner">
					<div class="layout__nav">
						<Nav :page="page"/>
					</div>
					<div class="layout__view">
						<Loader v-show="$root.isLoading" :loading="$root.isLoading"/>
						<div v-show="!$root.isLoading">
							<router-view v-slot="{ Component }">
								<transition name="fade" mode="out-in">
									<component :is="Component" />
								</transition>
							</router-view>
						</div>
					</div>

					<div>
						<div class="alert alert-danger alert-dismissible fade" role="alert"
							 v-if="user !== null && user.ban">
							Ваш аккаунт заблокирован. Причина: {{ user.ban_reason ? user.ban_reason : 'не указана' }}
						</div>
					</div>

				</div>
				<div class="layout__history" v-show="gameHistory && !hideHistory">
					<HistorySlots v-if="liveHistory">
						<template #btn v-if="!isTablet">
							<FixedBtn @hide-state="handlerHideHistory"/>
						</template>
					</HistorySlots>
					<AllHistory v-else/>
				</div>
			</div>
			<div class="layout__footer">
				<Footer />
			</div>
		</div>
	</div>

	<div v-if="user && user.impersonate" class="impersonate">
		<a :href="user.impersonate" class="btn user-menu__button btn--block btn--white">
			Выйти с аккаунта
		</a>
	</div>
	
	<MobNavbar v-if="isMob"/>
	<teleport to="body">
		<Modal :openState="singIn" @close="singIn = false" :data="{title: 'Авторизация'}">
			<SignIn @close="singIn = false" />
		</Modal>
		<Modal :openState="singUp" @close="singUp = false" :data="{title: 'Создание аккаунта'}">
			<SignUp @open-sing-in="() => {singUp = false; singIn = true}"/>
		</Modal>
	</teleport>
	<Notification />
	<!-- <Draw v-if="showDraw"/> -->
</template>

<script>
	import Footer from "./Footer/Footer.vue";
	import SignIn from "./Modals/SignIn.vue";
	import UserMenu from "./Modals/UserMenu.vue";
	import PinModal from "./Modals/Pin.vue";
	import Deposit from "./Modals/Deposit.vue";
	import Sidebar from "./Navigation/Sidebar.vue";
	import HistorySlots from "./History/Slots.vue";
	import GameNav from "./Navigation/GameNav.vue";
	import Sprite from "./Sprite.vue";
	import MobNavbar from "./blocks/MobNavbar.vue";
	import Nav from "./blocks/Nav.vue";
	import { mapState } from 'pinia';
	import { useUserStore } from './../stores/User';
	import breakpointsMixin from "../mixins/breakpoints-mixin.vue";
	import Social from "./blocks/Social.vue";
	import Modal from "./blocks/Modal.vue";
	import SignUp from "./Modals/SignUp.vue";
	import AllHistory from "../components/History/AllHistory.vue";
	import Loader from "./blocks/Loader.vue";
	import Notification from "./blocks/Notification.vue";
	import FixedBtn from "./blocks/FixedBtn.vue";
	import Draw from "./blocks/Draw.vue";

	export default {
		components: {
			SignUp,
			Modal,
			Social,
			Nav,
			MobNavbar,
			Sprite,
			AllHistory,
		    SignIn,
		    UserMenu,
		    PinModal,
		    Deposit,
		    Sidebar,
		    HistorySlots,
		    Footer,
		    GameNav,
			Loader,
			Notification,
			FixedBtn,
			Draw
		},

		mixins: [
			breakpointsMixin
		],

		data() {
		    return {
				singIn: false,
				singUp: false,
				hideHistory: false
		    }
		},

		computed: {
			...mapState(useUserStore, ['user']),

			page() {
				return this.$route.name;
			},

			gameHistory() {
				return this.$route.meta.history
			},

			liveHistory() {
				return ['slots', 'live', 'index', 'slotsGame'].includes(this.$route.name);
			},

			gameMobNav() {
				return !this.isMob || ['dice', 'mines', 'slots', 'live', 'coinflip'].includes(this.$route.name);
			},

			showDraw() {
				return (this.user && this.user.is_admin) || window.location.hostname === 'localhost';
			}
		},

		watch: {
			['user'](state) {
				if (state) {
					this.singIn = false;
					this.singUp = false;
				}
			},

			isTablet(state) {
				if (state) {
					this.hideHistory = false;
				}
			}
		},

		mounted() {
			this.$root.emitter.on('openAuth', () => this.singIn = true);
		},

		methods: {
			handlerHideHistory(state) {
				this.hideHistory = state;
			}
		}
	}
</script>